<template>
    <div>
        <tsoft-table
            :id="id"
            :name="'finance'"
            :nameClient="'finance'"
            :api="tableApiUrl"
            :items.sync="items"
            :exportXLSX="exportXLSX"
            :isNeedSearch="true"
            :isNeedCreate="false"
            :isNeedSelection="false"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="typeOfTableFilter"
            :customAddButtonName="'Создать счет'"
            :onDataEmptyMessage="'Счета отсутствуют. Создайте новый счет в заказе.'"
            :headerContextMenuName="'financeTable'"
            @show="showItem"
            @askFinanceOperation="askFinanceOperation"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_FINANCE } from "@/constants";

import {
    defaultDataItems,
    actionShowItem,
    actionCreateOrUpdateItem,
} from '@/mixins';
import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';

const initialEditedItem = () => ({
    id: '',
    invoice_type: 'incoming',
    invoice_number: '',
    order_id: '',
    order: {},
    external_company_id: '',
    external_company: {},
    company_id: 1305,
    company: {},
    order_service_id: '',
    service: {},
    reference_service_id: '',
    service_for_partner: {},
    creator_user_id: '',
    creator: {},
    reference_currency_id: 122,
    services_list: {
        data: [],
        itog: 0
    },
    sum_currency: '',
    sum: 0,
    with_nds: true,
    size_nds: (() => {
        const currentYear = new Date().getFullYear();
        return currentYear >= 2026 ? 22 : 20;
    })(),
    zero_rate: 0,
    natural: 0,
    turning: null,
    draft: 0,
    sum_difference: '',
    sum_payment: 0,
    commission_bank: '',
    realization_datetime: '',
    invoice_datetime: '',
    payment_datetime: '',
    documents: [],
    payer_company_id: 1305,
    payer_company: {}
})

export default {
    mixins: [
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        openFinanceSidebar
    ],
    props: {
        id: { type: String },
        full_order: { type: Object, required: false },                              // Full order object
        exportXLSX: { type: String, required: false },                              // If need export xlsx
        order_id: { type: Number|String, required: false },
        company_id: { type: Number|String, required: false },
        order_service_id: { type: Number|String, required: false },
        allowed_services: { type: Array, required: false },                         // Services linked to the order to limit the list of services
        isNeedCreate: { type: Boolean, required: false, default: true },            // If table needs create new element button
        additionalGetParameter: { type: String, required: false, default: '' },     // If we want to add something, for example, &order_id=10
        typeOfTableFilter: { type: String, required: false, default: '' },          // Type of filter for output: orders, services
        isNeedSubtotal: { type: Boolean, required: false, default: false },         // If table needs subtotal under line
    },
    data() {
        return {
            model_name: ['App\\Models\\Finance'],
            tableApiUrl: API_FINANCE,
            notRubles: false,
            createFinanceRequestByIndex: -1,
            checkedLoadDocument: false, //do i need a document
            idCreatedFinance: '',       //id new finance for uploading documents
            requestDocuments: false,    //sign for document output by order
            uploadDocumentsNow: false,  // Trigger for loading new documents on save button click
        }
    },
    watch: {
        'editedItem.invoice_type'(invoice_type){
            if (this.editIndex == -1) {
                this.editedItem.natural = 0
                this.editedItem.zero_rate = 0
                this.editedItem.with_nds = true
                this.editedItem.size_nds = this.getDefaultNds()
                this.editedItem.draft = 0
            }
        },
        'editedItem.zero_rate'(value){
            if (value == 1) {
                this.editedItem.natural = 0
                this.editedItem.with_nds = 0
                this.editedItem.size_nds = 0
            }
        },
        'editedItem.with_nds'(value){
            if (value == 1) {
                this.editedItem.natural = 0
                this.editedItem.zero_rate = 0

                if (this.editIndex == -1) {
                    this.editedItem.size_nds = this.getDefaultNds()
                }
            }
        },
        'editedItem.natural'(value){
            if (value == 1) {
                this.editedItem.zero_rate = 0
                this.editedItem.with_nds = 0
                this.editedItem.size_nds = 0
            }
        },
        'editedItem.services_list.data': {
            deep: true,
            handler: 'recheckNumbersInServicesList'
        },
        'editedItem.order_service_id'(value){
            this.createServicesListByServiceData(value)
        },
        invoiceTypeSelected(options) {
            this.editedItem.invoice_type = options.value
        },
    },

    computed: {
        ...mapGetters('auth', ['currentUser']),
    },

    mounted() {
        this.editedItem = initialEditedItem();
        this.initialAssign();
    },
    methods: {
        getDefaultNds() {
            // С 2026 года используется НДС 22%, до этого - 20%
            const currentYear = new Date().getFullYear();
            return currentYear >= 2026 ? 22 : 20;
        },
        initialAssign() {
            if (this.order_id) {
                this.editedItem.order_id = this.order_id
            }
            if (this.company_id) {
                this.editedItem.external_company_id = this.company_id
            }
            if (this.order_service_id) {
                this.editedItem.order_service_id = this.order_service_id
            }
        },
        // calls from mixin before sidebaropened
        beforeSidebarOpenedCallback() {
            this.editedItem = initialEditedItem()
            this.checkedLoadDocument = false
            this.idCreatedFinance = ''
            this.requestDocuments = false
            this.uploadDocumentsNow = false
            this.initialAssign()
        },
        // calls from mixin on item save
        onCreatedOrUpdatedCallback(orderId) {
            this.idCreatedFinance = orderId.id
            if (this.checkedLoadDocument == false) {
                this.isSidebarOpen = false
            }
            this.uploadDocumentsNow = true
        },
        setCurrencyOfOperation(value) {
            this.editedItem.reference_currency_id = value
            this.editedItem.sum = 0
            this.editedItem.sum_currency = ''
            if (this.editedItem.reference_currency_id != 122) {
                this.notRubles = true
            } else {
                this.notRubles = false
            }

            this.recheckNumbersInServicesList()
        },
        askFinanceOperation(index) {
            this.createFinanceRequestByIndex = index
        },
        closeFinanceRequest() {
            this.createFinanceRequestByIndex = -1
            this.$emit('refreshFinanceRequests')
        },
        checkDebt() {
            if (this.editedItem.sum) {
                return this.editedItem.sum - this.editedItem.sum_payment
            } else {
                return 0
            }
        },
        countNds(invoice_type, reference_currency_id = 122) {
            let sum = 0
            let startSum = Number(this.editedItem.sum)
            let text = ''
            let drTitle = 'Доход'
            let willBeText = 'будет'
            let valuteName = 'р.'

            if (invoice_type == 'outgoing') {
                drTitle = 'Расход'
                willBeText = 'нужен'
            }

            if (reference_currency_id != 122) {
                valuteName = '$'
                if (reference_currency_id == 123) valuteName = '€'
                if (reference_currency_id == 378) valuteName = '￥'
                if (reference_currency_id == 591) valuteName = '₺'
                if (reference_currency_id == 906) valuteName = '֏'
                if (reference_currency_id == 908) valuteName = 'د.إ'
                
                startSum = Number(this.editedItem.sum_currency)
                this.editedItem.sum = 0
            } else {
                this.editedItem.sum_currency = ''
            }

            if (this.editedItem.with_nds == 0) {
                sum = startSum
                text = `Счет ${willBeText} на ${sum.toFixed(2)} ${valuteName} / ${drTitle} ${startSum.toFixed(2)} ${valuteName}`
            } else {
                // sum = startSum / 1.2
                let nds_percent = this.editedItem.size_nds ? this.editedItem.size_nds : this.getDefaultNds(); // Используем размер НДС из данных или дефолтное значение
                sum = startSum / (1 + nds_percent / 100);

                text = `Счет ${willBeText} на ${startSum.toFixed(2)} ${valuteName} / ${drTitle} ${sum.toFixed(2)} ${valuteName}`
            }

            if (this.editedItem.zero_rate == 1) {
                sum = startSum
                text = `Счет ${willBeText} на ${sum.toFixed(2)} ${valuteName} / ${drTitle} ${startSum.toFixed(2)} ${valuteName}`
            }

            if (this.editedItem.natural == 1) {
                return ''
            }

            return text
        },
        countTurningSum() {
            let itogSum = 0
            let valuteName = 'р.'

            if (this.editedItem.sum_currency) {
                itogSum = this.editedItem.sum_currency * this.editedItem.turning / 100
                valuteName = '$'
                if (this.editedItem.reference_currency_id == 123) valuteName = '€'
                if (this.editedItem.reference_currency_id == 378) valuteName = '￥'
                if (this.editedItem.reference_currency_id == 591) valuteName = '₺'
                if (this.editedItem.reference_currency_id == 906) valuteName = '֏'
                if (this.editedItem.reference_currency_id == 908) valuteName = 'د.إ'
            } else {
                itogSum = this.editedItem.sum * this.editedItem.turning / 100
            }

            return `Вознаграждение ${itogSum.toFixed(2)} ${valuteName}`
        },
        minDateForBill() {
            let now = new Date()
            let formattedDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();

            return formattedDate
        },
        addOneToServicesList(data = {}) {
            this.editedItem.services_list.data.push({
                id: this.editedItem.services_list.data.length + 1,
                name: (data.name ? data.name : ''),
                number: (data.number ? data.number : 1),
                sum: (data.sum ? data.sum : 0),
            })
        },
        recheckNumbersInServicesList() {
            this.editedItem.services_list.itog = 0
            this.editedItem.services_list.data.forEach((service, index) => {
                service.id = index + 1
                this.editedItem.services_list.itog += Number(service.sum * (service.number ? service.number : 1))
            })

            this.editedItem.services_list.itog = this.editedItem.services_list.itog.toFixed(2)
            if (!this.notRubles) {
                this.editedItem.sum = this.editedItem.services_list.itog
            } else {
                this.editedItem.sum_currency = this.editedItem.services_list.itog
            }
        },
        createServicesListByServiceData(service_id) {
            if (this.full_order && this.full_order.services_info) {
                this.editedItem.services_list = {
                                                    data: [],
                                                    itog: 0
                                                }     // clean up services list
                let TEO = {
                    tsList: [],                       // 276 - номера ТС
                    start_town: '',                   // 269 - Город загрузки
                    end_town: ''                      // 270 - Город выгрузки
                }                                     // list of transports for TEO {}
                let TO = {
                    tsList: [],
                    dtList: []
                }
                if (this.full_order.services_info[service_id]) {
                    this.full_order.services_info[service_id].forEach((property, index) => {
                        // if we have DT(257 reference_property), so TO service
                        if (property.reference_service_property_id == 257) {
                            TO.dtList.push(property.value)
                        }
                        // if we have TS(253 reference property), so TO service
                        if (property.reference_service_property_id == 253) {
                            TO.tsList.push(property.value)
                        }
                        // if we have consulting field (295 - type of service) so add consulting service in list
                        if (property.reference_service_property_id == 295) {
                            this.addOneToServicesList({
                                name: `Консультирование по вопросам ТО `
                            })
                        }
                        // START: TEO prepare block
                        if (property.reference_service_property_id == 269) {
                            TEO.start_town = property.value
                        }
                        if (property.reference_service_property_id == 270) {
                            TEO.end_town = property.value
                        }
                        if (property.reference_service_property_id == 276) {
                            TEO.tsList.push(property.value)
                        }
                        // END: TEO prepare block
                    })

                    // if we have transport numbers in array so make service list
                    if (TEO.tsList.length > 0) {
                        TEO.tsList.forEach((tsNumber) => {
                            this.addOneToServicesList({
                                name: `Транспортно-экспедиционное обслуживание (ТЭО) по маршруту: ${TEO.start_town} - ${TEO.end_town}, ${tsNumber}`
                            })
                        })
                    }
                    // if we have DT numbers in array so make service list
                    if (TO.dtList.length > 0) {
                        let tsListString = TO.tsList.join(', ')
                        TO.dtList.forEach((dtNumber) => {
                            this.addOneToServicesList({
                                name: `Услуги по таможенному оформлению ДТ №${dtNumber}, ${tsListString}`
                            })
                        })
                    }


                }
            }
        },
        // call from action js
        onItemEditModalCallback() {
            if (typeof this.editedItem.services_list === 'string') {
                this.editedItem.services_list = JSON.parse(this.editedItem.services_list)
            }
        },
        // closing after loading the document
        onCloseSidePanelLoadingDocument(value) {
            if (value == true) {
                this.checkedLoadDocument = false
                this.idCreatedFinance = ''
                this.uploadDocumentsNow = false
                this.isSidebarOpen = false
            }
        },
    }
}
</script>
